import Tooltip from "../../../components/tooltip/Tooltip";
import {Badge} from "react-bootstrap";
import React from "react";
import * as PropTypes from "prop-types";

export function DaysSinceLastCleaningBadge(props) {
    return <Tooltip tooltip={"Dni od ostatnego czyszczenia"} placement={props.placement || "left"}>
        <Badge className={"mr-1 font-max"}
               variant={props.part.daysSinceLastCleaning > props.cleaningValidDuration ? "danger" : "primary"}>{props.part.daysSinceLastCleaning}</Badge>
    </Tooltip>;

}

DaysSinceLastCleaningBadge.propTypes = {
    part: PropTypes.any,
    cleaningValidDuration: PropTypes.any
};